
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ allowedRoles, children }) {
  const { user, isLoggedIn } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    // اگر لاگین نکرده → بفرستش صفحه لاگین
    return <Navigate to="/user-login" state={{ from: location }} replace />;
  }

  // اگر نقش کاربر در allowedRoles نیست
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    alert("شما به این صفحه دسترسی ندارید.");
    // بفرستش به پنل خودش
    return <Navigate to={`/${user.role}-panel`} replace />;
  }

  // اگر مجاز بود، بچه‌ها رو نشون بده
  return children;
}
